import NextImage from "next/image";
import { TextD2C } from "@/scott/ui/elements/text-d2c/text";
import type { ProductDetailIncludedProduct } from "../product-detail-page.adapter";

export interface ProductIncludedProductsSectionProps {
  products: ProductDetailIncludedProduct[];
  microcopies: {
    title: string;
  };
}

export function ProductIncludedProductsSection(
  props: Readonly<ProductIncludedProductsSectionProps>
) {
  if (props.products.length === 0) {
    return null;
  }

  return (
    <div>
      <TextD2C style="bold" variant="p-small">
        {props.microcopies.title}
      </TextD2C>

      <div className="space-y-3 pt-1">
        {props.products.map((product) => (
          <div
            className="flex items-center gap-2 pb-6 last:pb-0"
            key={product.code}
          >
            <div className="w-[60px] shrink-0">
              {product.mainAsset && (
                <NextImage
                  alt={product.name}
                  height={60}
                  src={product.mainAsset}
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "auto",
                  }}
                  width={60}
                />
              )}
            </div>

            <div className="flex-1">
              <TextD2C style="no-mb" variant="p-small">
                <span className="font-bold">{product.name}</span>
              </TextD2C>
              {product.lensesSpecifications?.map((spec) => (
                <TextD2C key={spec.name} style="no-mb" variant="p-small">
                  {spec.name} {spec.values[0] ?? ""}
                </TextD2C>
              ))}
            </div>

            <div className="w-[28px] shrink-0">
              {product.weatherConditionImages?.[0] && (
                <NextImage
                  alt=""
                  height={28}
                  src={product.weatherConditionImages[0]}
                  width={28}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
